import {
  ContactDetailResType,
  ContactSaveType,
  SearchContactMapType,
  SearchContactType,
} from "../../pages/customer/contact/interface";
import { AccountSearchInterface } from "../../pages/customer/correspondent/list/interface/searchInterface";
import { CommonSelectType } from "../../types/common/basic";
import {
  ErrorType,
  ResponseResType,
  SuccessType,
} from "../../types/common/response";
import { baseApi } from "../../util/axiosConfig";

/**
 * 연락처관리
 */
const url = "api/customer/contact/";

/**
 * 연락처 리스트
 * @param data
 * @returns
 */
export async function readContactListApi(
  data: AccountSearchInterface & { accountId: string }
): Promise<ResponseResType<SearchContactMapType> | ErrorType> {
  const response = await baseApi.post(url + "read_contact_list", data);
  return response?.data;
}

/**
 * 연락처 상세검색
 * @param data
 * @returns
 */
export async function readContactDetailApi(
  data: SearchContactType
): Promise<ResponseResType<ContactDetailResType> | ErrorType> {
  const response = await baseApi.post(url + "read_contact_detail", data);
  return response?.data;
}

/**
 * 연락처 엑셀 다운로드
 */
export async function exportContactExcelApi(
  data: AccountSearchInterface
): Promise<Blob | ArrayBuffer | Uint8Array | string | ErrorType> {
  const response = await baseApi.post(url + "export_contact_excel", data, {
    responseType: "blob",
  });

  return response?.data;
}

/**
 * 연락처 저장 (등록/수정)
 */
export async function saveContactApi(
  data: ContactSaveType
): Promise<SuccessType | ErrorType> {
  const response = await baseApi.post(url + "save_contact", data);
  return response?.data;
}

/**
 * 컨택 경로 select box
 * @returns
 */
export async function readContactPathSelectBoxApi(): Promise<
  ResponseResType<CommonSelectType[]> | ErrorType
> {
  const response = await baseApi.post(url + "read_contact_path_select_box");
  return response?.data;
}

/**
 * 연락처 삭제
 * @param data
 * @returns
 */
export async function deleteContactApi(
  data: {
    id: string;
  }[]
): Promise<SuccessType | ErrorType> {
  const response = await baseApi.post(url + "delete_contact", data);
  return response?.data;
}
